/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Template_Min_Gap_ConfirmInputs */



/**
* | output |
* | --- |
* | "Create Template" |
*
* @param {Ad_Template_Min_Gap_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_template_min_gap_confirm = /** @type {((inputs?: Ad_Template_Min_Gap_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Template_Min_Gap_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer le modèle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorlage erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea modello")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать шаблон")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear plantilla")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建模板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テンプレートを作成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेम्पलेट बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar modelo")
	return /** @type {LocalizedString} */ ("Create Template")
});